import { FC, memo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import Input from '~/ui/components/inputs/Input';
import { fieldMax500 } from '~/ui/constants/errorMessages';

interface IProps {
  memoFieldName: string;
}

const MAX_MEMO_LENGTH = 500;

const MemoField: FC<IProps> = ({ memoFieldName }) => {
  const {
    register,
    formState: { errors },
    clearErrors,
    setError,
    watch,
  } = useFormContext();
  const memoValue = watch(memoFieldName);

  useEffect(() => {
    if (memoValue?.length > MAX_MEMO_LENGTH) {
      setError(memoFieldName, { message: fieldMax500 });
    }
    if (errors[memoFieldName] && memoValue?.length <= MAX_MEMO_LENGTH) {
      clearErrors(memoFieldName);
    }
  }, [memoValue, memoFieldName, setError, clearErrors, errors]);

  return (
    <Input tabIndex={-1} register={register} errors={errors} name={memoFieldName} label="Memo" />
  );
};

export default memo(MemoField);
